import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild, viewChild, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RekbotsService } from '../../services/rekbots.service';
import { Rekbot } from '../../models/rekbot.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { RekbotSettingsComponent } from '../rekbot-layout/rekbot-settings/rekbot-settings.component';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';
import { RekbotCardComponent } from '../rekbot-card/rekbot-card.component';
import { MatCardModule } from '@angular/material/card';
import { combineLatest, map, Observable, of, startWith, tap } from 'rxjs';
import { TableRekbotListComponent } from '../table-rekbot-list/table-rekbot-list.component';
import { MatSelectModule } from '@angular/material/select';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { OrganizationsService } from '../../services/organizations.service';
import { Organization } from '../../models/organization.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../services/auth.service';


@Component({
  selector: 'app-rekbots-list',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonToggleModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    //MatTooltip,
    MatCardModule,
    CommonModule,
    TableRekbotListComponent,
    MatSelectModule,
    MatTabsModule,
    MatProgressSpinner,
    MatAutocompleteModule
],
  templateUrl: './rekbots-list.component.html',
  styleUrl: './rekbots-list.component.scss',
  providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]
})

export class RekbotsListComponent implements AfterViewInit, OnInit, OnDestroy {


  private subscription: any;

  public viewTiles: boolean = true;
  public isLoading: boolean = true;
  public selectMode: boolean = false;
  public errorMessage: string = '' ;
  public labels: string[] = ['Customer', 'Installation', 'Warehouse'];
  public organizationsName: string[] = [];

  public rekbots: Rekbot[] = [];
  public warehouseRekbots: Rekbot[] = [];
  public installationRekbots: Rekbot[] = [];
  public customerRekbots: Rekbot[] = [];

  public organizationNames: string[] = [];
  public selectedOrganization: FormControl = new FormControl('');
  public organizations$: Observable<Organization[]> = new Observable<Organization[]>();
  public filteredOrganizationNames$: Observable <string[]> = new Observable<string[]>;

  public childrenState = [false,false,false]
  public prodStatus: number = -1

  public filter: FormControl = new FormControl('');
  public selectedStatus: FormControl = new FormControl<string[]>([]) ;
  public selectedRekbots: number = 0 ;

  public oRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();
  public filteredRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();

  public warehouseRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();
  public installationRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();
  public customerRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();

  

  public filterValue$: Observable<string> = new Observable<string>();
  public selectedStatus$: Observable<string[]> = new Observable<string[]>()
  public selectedOrganization$: Observable<string> = new Observable<string>()
  
  userPermission: number = 0

  public dataSource = new MatTableDataSource<any>(this.rekbots);


  public rekbotStatuses = [
    {
      value: 0,
      name: 'ERROR'
    },
    {
      value: 1,
      name: 'OK'
    }]


  public displayedColumns: string[] = [
    'id',
    'serial_no',
    'connection',
    'status',
    'empty_col',
    'action'
  ];


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('content') content: any;

  constructor(
    private rekbotsService: RekbotsService,
    private authService: AuthService,
    private modalService: NgbModal,
    public router: Router,
    public cd: ChangeDetectorRef,
    private organizationsService: OrganizationsService,
    private snackBar: MatSnackBar,
  ) {
  }


  ngOnDestroy(): void {
    if (this.subscription) {

      this.subscription.unsubscribe();
    }
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }

  ngOnInit(): void {
    this.userPermission = this.authService.getUser()!.role!.role_id;
    console.log("ngOnInit dataSource", this.dataSource);
    this.fetchRekbots();
    this.fetchOrganizations();

    
  }

  fetchRekbots(): void {
    const savedFilterSerial = sessionStorage.getItem('rekbotTableFilterSerial');
    const savedStatus = sessionStorage.getItem('rekbotTableFilterStatus');
    const savedOrganization = sessionStorage.getItem('rekbotTableFilterOrganization');
    const savedTabIndex = sessionStorage.getItem('rekbotListTabIndex');
    
    if(savedFilterSerial) this.filter.setValue(savedFilterSerial);
    if(savedStatus) this.selectedStatus.setValue(JSON.parse(savedStatus));
    if(savedOrganization) this.selectedOrganization.setValue(savedOrganization);
    if(savedTabIndex) this.selectedRekbots = Number(savedTabIndex)

    this.rekbotsService.fetchRekbots()
      .subscribe({
        next: (response: any) => {
          
          // console.log("fetchRekbots", this.oRekbots$);

          this.rekbots = response.map((el: Rekbot) => {
            let newEl = el
            newEl.namedStatus = (el.status === 0) ? "ERROR" : "OK"
            return newEl
          })

          // this.filter = new FormControl('');
          // this.selectedStatus = new FormControl('');
          this.filterValue$ = this.filter.valueChanges.pipe(startWith(savedFilterSerial || ''));
          this.selectedStatus$ = this.selectedStatus.valueChanges.pipe(startWith(savedStatus ? JSON.parse(savedStatus) : []));
          this.selectedOrganization$ = this.selectedOrganization.valueChanges.pipe(startWith(savedOrganization || ''));

          this.oRekbots$ = of(this.rekbots);
          // Jeśli status rekbota jest 0: to OK 1: ERROR
          this.filteredRekbots$ = combineLatest([this.oRekbots$, this.filterValue$, this.selectedStatus$, this.selectedOrganization$]).pipe(
            map(([rekbots, filterValue, selectedStatus, selectedOrganization]) => {
              // console.log("mapping filteredRekbots$", rekbots, filterValue,selectedValue)
             
              return rekbots.filter(rekbot => {
                const matchesSerial = rekbot.serial_no.toLowerCase().includes(filterValue.toLowerCase());

                let status: string ;
                if(!this.isOnline(rekbot)){
                  status = '2'
                }else {
                  status = rekbot.status.toString()
                }
                
                const matchesStatus = selectedStatus.length === 0 || selectedStatus.includes(status);

                let selectedOrgState = true
                if(selectedOrganization !== '') {
                  selectedOrgState = rekbot.organization ? rekbot.organization.name.toLowerCase().includes(selectedOrganization.toLowerCase()) : false
                }
                const matchesOrganization = selectedOrgState
                // console.log("matchesOrganization" , matchesOrganization)
                 
                return matchesSerial && matchesStatus && matchesOrganization;
              })
              
              
            })
          );
          this.viewTiles = false;

          this.warehouseRekbots$ = this.filteredRekbots$.pipe(
            map(rekbots =>
              rekbots.filter(r => r.production_status != 1 && r.production_status != 2)
            ),
            tap(filtered => {
              // console.log("Wearhouse: ",filtered);
              this.warehouseRekbots = filtered
            })
          );

          this.installationRekbots$ = this.filteredRekbots$.pipe(
            map(rekbots =>
              rekbots.filter(r => r.production_status === 1)
            ),
            tap(filtered => {
              // console.log("Installation: ",filtered);
              this.installationRekbots = filtered
            })
          );

          this.customerRekbots$ = this.filteredRekbots$.pipe(
            map(rekbots =>
              rekbots.filter(r => r.production_status === 2)
            ),
            tap(filtered => {
              // console.log("Customer: ",filtered);
              this.customerRekbots = filtered
            })
          );

          this.isLoading = false;

        },
        error: error => {
          this.isLoading = false;
          
          console.error("fetchrekbots error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
            this.errorMessage = "Coś poszło nie tak :/"
          } else {
             this.errorMessage = "Coś poszło nie tak :/"
          }
        }
      });

    // this.subscription = this.filteredRekbots$.subscribe({
    //   next: (response: any) => {
    //     console.log("getFilteredRekbots from subscription", response)
    //     this.rekbotsService.setFilteredRekbots(response)
    //   }
    // });
  }

  fetchOrganizations() {
    this.organizationsService.fetchOrganizations()
    .subscribe({
      next: (response: any) => {
        this.organizationNames = response.map((org: Organization) => org.name);
        // console.log("Wgrane nazwy organizacji:",this.organizationNames);
        this.filteredOrganizationNames$ = this.selectedOrganization.valueChanges.pipe(
          startWith(''),
          map(value => this.organizationNames.filter(org => org.toLowerCase().includes(value.toLowerCase()))),
        );
    
          },
      error: (error:any) => {
        console.log(error);
        if (error.status === 401) {
          this.router.navigate(['/login']);
        }
      }
    });
  }

  doFilter(event: Event) {
    //let value = filterValue.target.value
    const filterValue = (event.target as HTMLInputElement).value;

    // console.log("do filter arg", filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  toggleViewType() {
    this.viewTiles = !this.viewTiles;
  }
  
  isOnline(rekbot: Rekbot) {
    if (rekbot.status == 1) {
      return true
    } else if (rekbot.status == 0) {

      if (rekbot.log_last_entry == null) {
        return false
      } else {

        if (rekbot.log_last_entry.length > 0) {

          let last_entry = rekbot.log_last_entry[0];

          if (last_entry.message!.includes("Curl error")) {
            return false;
          } else {
            return true;
          }

        } else {
          return false
        }

      }
    }
    return false
  }

  clearFilters() {
    this.filter.setValue('');
    this.selectedStatus.setValue([]);
    this.selectedOrganization.setValue('');
    
    sessionStorage.removeItem('rekbotTableFilterSerial')
    sessionStorage.removeItem('rekbotListTabIndex')
    sessionStorage.removeItem('rekbotListTablePage');
    sessionStorage.removeItem('rekbotListTableSort');
    sessionStorage.removeItem('rekbotTableFilterOrganization')

    this.labels.forEach(label => {
      sessionStorage.removeItem(`rekbot${label}TablePage`);
      sessionStorage.removeItem(`rekbot${label}TableSort`);
    })
  }

  saveFilter() {
    sessionStorage.setItem('rekbotTableFilterSerial', this.filter.value)
    // console.log("Zapisany filter: ", this.filter.value);
  }

  saveStatus() {
    sessionStorage.setItem('rekbotTableFilterStatus', JSON.stringify(this.selectedStatus.value))
    // console.log("Zapisany filter statusu: ", this.selectedStatus.value);
  }

  saveOrg() {
    sessionStorage.setItem('rekbotTableFilterOrganization', this.selectedOrganization.value)
    // console.log("Zapisuje org: ", this.selectedOrganization.value);
  }

  onTabChange(event: MatTabChangeEvent) {
    this.prodStatus = -1;
    this.selectMode = false
    this.childrenState[this.selectedRekbots] = this.selectMode;

    this.selectedRekbots = event.index;
    sessionStorage.setItem('rekbotListTabIndex', this.selectedRekbots.toString()) 
  }
  
  onMapOpen() {
    
    switch(this.selectedRekbots){
      case 0:
        this.rekbotsService.setFilteredRekbots(this.customerRekbots);
        break;
      case 1:
        this.rekbotsService.setFilteredRekbots(this.installationRekbots);
        break;
      case 2:
        this.rekbotsService.setFilteredRekbots(this.warehouseRekbots);
        break;
      default:
        this.rekbotsService.setFilteredRekbots(this.customerRekbots);
    }
    // console.log("wybrane Rekboty id: ",this.selectedRekbots, "zmienione rekboty: ", this.rekbotsService.getFilteredRekbots());

    this.router.navigate(['rekbot-location'])
  }

  doFilterTag(name:string) {
    this.selectedOrganization.setValue(name)
  }
  
  onToggleSelect() {
    this.selectMode = !this.selectMode
    this.childrenState[this.selectedRekbots] = this.selectMode;
  }

  setProdStatus(status_id: number) {
    this.prodStatus = status_id
  }

  onProdStatusSubmit() {
    this.childrenState[this.selectedRekbots] = false;
    this.selectMode = false;
  }

  handleChangeState(rekbot_ids: number[]) {
    // console.log("wywołanie handleChangeState");
    
    if(this.prodStatus != -1) {
      console.log("Ziana submited rekbotów: ",rekbot_ids, "na status: ",this.prodStatus);
      
      this.rekbotsService.changeProductionStatus(rekbot_ids, this.prodStatus).subscribe({
        next: res => {
          console.log(res);
          this.isLoading = true;
          this.fetchRekbots();
          this.snackBar.open(
              'Rekboty zmienione',
              'OK',
              {duration:3000}
            );
        },
        error: err => {
          console.error(err);
          if(err.status === 422) {
            this.snackBar.open(
              'Brak wybranych Rekbotów',
              'OK',
              {duration:3000}
            );
          } else {
            this.snackBar.open(
              'Coś poszło nie tak: ' + err.status,
              'OK',
              {duration:3000}
            );
          }
        }
      })
    }
  }
  onCancelProdStatus() {
    this.prodStatus = -1;
    this.selectMode = false;
    this.childrenState[this.selectedRekbots] = false;
  }
}
